import { render, staticRenderFns } from "./seeApp.vue?vue&type=template&id=88d52630&scoped=true"
import script from "./seeApp.vue?vue&type=script&lang=js"
export * from "./seeApp.vue?vue&type=script&lang=js"
import style0 from "./seeApp.vue?vue&type=style&index=0&id=88d52630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d52630",
  null
  
)

export default component.exports